import "../../utils/tailwind.css";
import cx from "../../utils/tailwind-merge";

const CustomButton = ({
  children,
  variant = "default",
  onClick,
  disabled = false,
  className,
  ...props
}) => {
  const baseStyles =
    "px-4 py-2 !rounded-[8px] text-sm font-medium transition duration-300";

  const buttonVariants = {
    outlineRed:
      "bg-transparent border border-primary text-primary hover:bg-primary hover:text-white border-[#FB325E] border-[1px] text-[#FB325E] text-[16px] !font-[400] w-[120px] h-[48px] !p-0 hover:!text-white hover:!bg-[#FB325E]",
    default:
      "bg-[#030712] border border-primary text-primary !text-white border-[#030712] border-[1px] text-[#030712] text-[16px] !font-[400] w-[120px] h-[48px] !p-0 hover:!text-black hover:!bg-white border-black",
    outline:
      "bg-transparent border border-primary text-primary hover:bg-primary hover:text-white border-[#030712] border-[1px] text-[#030712] text-[16px] !font-[400] w-[120px] h-[48px] !p-0 hover:!text-white hover:!bg-[#030712]",
    disabled:
      "bg-gray-500 border-gray-500 text-white cursor-not-allowed opacity-50 w-[120px] h-[48px] text-[16px]",
    secondary:
      "bg-[#EBEAF7] !text-[#030712] text-[13px] !font-[400] min-w-[130px] !h-fit  !p-0 !rounded-[8px] hover:!bg-[#030712] hover:!text-white",
  };

  const buttonClasses = `${baseStyles} ${
    disabled ? buttonVariants.disabled : buttonVariants[variant]
  }`;

  return (
    <button
      className={cx(buttonClasses, className)}
      onClick={onClick}
      disabled={disabled}
      {...props}>
      {children}
    </button>
  );
};

export default CustomButton;
